export function buildAddressText(value, countryOptions) {
    var _a, _b;
    var countryLabel = (_b = (_a = countryOptions.find(function (option) { return option.code === value.country; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value.country;
    return [
        value.addressLine,
        [value.zipCode, value.city].filter(Boolean).join(' '),
        value.state,
        countryLabel
    ]
        .filter(Boolean)
        .join(', ');
}
